<script setup>
import { computed } from 'vue';

const props = defineProps({
  content: {
    type: String,
    default: '',
  },
});

const URL_PATTERN = /(https?:\/\/[^\s]+)/gi;

const segments = computed(() => {
  const parts = [];
  let cursor = 0;
  props.content.replace(URL_PATTERN, (url, _match, offset) => {
    if (offset > cursor) {
      parts.push({ type: 'text', value: props.content.slice(cursor, offset) });
    }
    parts.push({ type: 'link', value: url });
    cursor = offset + url.length;
    return url;
  });
  if (cursor < props.content.length) {
    parts.push({ type: 'text', value: props.content.slice(cursor) });
  }
  return parts;
});
</script>

<template>
  <p class="m-0 whitespace-pre-wrap break-words text-sm leading-5">
    <template v-for="(segment, index) in segments" :key="index">
      <a
        v-if="segment.type === 'link'"
        :href="segment.value"
        target="_blank"
        rel="noopener noreferrer nofollow"
        class="break-all text-n-blue-text underline underline-offset-2 focus-visible:rounded-sm focus-visible:outline focus-visible:outline-1 focus-visible:outline-n-brand"
      >
        {{ segment.value }}
      </a>
      <template v-else>{{ segment.value }}</template>
    </template>
  </p>
</template>
